import React from "react";
import Tool from "../manager_tool";
import { BACKEND_URL } from "../../lib/DataSender";
import DataSender from "../../lib/ManagerDataSender";

class Id_Manager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      allcheck: false,
      check: false,
    };
    this.ds = new DataSender();
  }

  componentDidMount() {
    this.update();
  }

  update() {
    this.ds
      .getSoldier()
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          items: res.map((x) => {
            x["checked"] = false;
            return x;
          }),
        });
      })
      .catch((err) => {});
  }

  //===

  count(tis) {
    this.ds
      .getSoldierCount()
      .then((res) => res.json())
      .then((res) => {
        tis.setState({ allperson: res.count });
      })
      .catch((err) => {});
  }

  deleteSoldier() {
    let items = this.state.items.filter((x) => x.checked).map((x) => x.id);
    this.ds
      .deleteSoldier({ id: items })
      .then(() => this.update())
      .catch((err) => {});
  }

  updateSoldier(item) {
    this.ds
      .updateSoldier(item)
      .then(() => this.update())
      .catch((err) => {});
  }

  //==

  checkboxclick = (e) => {
    let id = parseInt(e.target.getAttribute("tid"));

    let items = [...this.state.items];
    let item = { ...this.state.items[id], checked: e.target.checked };
    items[id] = item;

    this.setState({ items });
  };

  checkAll = () => {
    let check = !this.state.allcheck;
    this.setState({
      items: this.state.items.map((x) => {
        return { ...x, checked: check };
      }),
      allcheck: check,
    });
  };

  render() {
    const items = this.state.items;
    const itt = this.state.items.find((x) => x.checked);
    return (
      <section>
        <div className="info02" style={{ width: "90%", marginLeft: "7%" }}>
          <div className="tb_w" style={{ width: "100%" }}>
            <h2>인원 목록</h2>
            <Tool
              item={itt}
              element={{
                name: "이름",
                phone_number: "전화번호",
                birth: "생년월일",
              }}
              delete={this.deleteSoldier.bind(this)}
              update={this.updateSoldier.bind(this)}
              count={this.count.bind(this)}
            />
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={this.props.allCheck}
                      onChange={this.checkAll.bind(this.measur)}
                    />
                  </th>
                  <th>이름</th>
                  <th>전화번호</th>
                  <th>생년월일</th>
                  <th>부대(소속)</th>
                  <th>QR</th>
                </tr>
              </thead>
              <tbody>
                {items.map((x, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        <input
                          id="check"
                          tid={i}
                          type="checkbox"
                          checked={x.checked}
                          onChange={this.checkboxclick}
                        />
                      </td>
                      <td className="col" data-label="이름">
                        {x.name}
                      </td>
                      <td>{x.phone_number}</td>
                      <td className="col" data-label="생년월일">
                        {x.birth}
                      </td>
                      <td className="col" data-label="부대(소속)">
                        {x.army_unit.unitName}
                      </td>
                      <td className="col" data-label="QR">
                        {/* img */}
                        <img
                          src={`${BACKEND_URL}/img/${x.qr_img}`}
                          width="64"
                          height="64"
                          alt="QR이미지"
                        ></img>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

export default Id_Manager;
